import React, { useState, Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { getListingsAxios, getSocialLinkAxios } from "../../Actions/axios";



const Exchangelist = () => {

  const navigate = useNavigate();
  //   const [cointokenList, setCointokenList] = useState([]);
  const [exchangeLists, setExchangeLists] = useState([]);
  console.log("exchangeListsexchangeLists", exchangeLists);

  const getExchangeList = async () => {
    let resp = await getListingsAxios({ section: "exchange" });
    console.log("🚀 ~ setExchangeLists ~ resp:", resp);
    if (resp?.status) {
      setExchangeLists(resp?.data?.data);
    }
  };


  const columns = [
    // {
    //   name: "S.no",
    //   align: "left",
    //   sortable: false,
    // //   selector: (row,i) => <p>{i+1}</p>,
    //   cell: (record) => {
    //        return (
    //          <Fragment>
    //           <p>1</p>
    //          </Fragment>
    //        );
    //      },
    // },
    {
      name: "Steps",
      align: "left",
      sortable: false,
      //   selector: (row) => row.title,
      cell: (record) => {
        return (
          <Fragment>
            <p>{record?.stepName}</p>
          </Fragment>
        );
      },
    },
    // {
    //   name: "Item Name",
    //   align: "left",
    //   sortable: false,
    // //   selector: (row) => row.title,
    //    cell: (record) => {
    //     console.log("record",record);
    //        return (
    //          <Fragment>
    //           <p>{record.type}</p>
    //          </Fragment>
    //        );
    //      },
    // },
    {
      name: "Action",
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className={`btn sitebtn btn-sm`}
              onClick={() => navigate("/exchangeedit", { state: record })}
            >
              <FaEdit />
            </button>
          </Fragment>
        );
      },
    },
  ];


  useEffect(() => {
    getExchangeList();
  }, []);

  return (

    <div className="cmslist">
      <h1 className="pagehead">Exchange Question List</h1>
      <div className="cardbox">
        <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
          <Link to="/exchangeadd" className="btn sitebtn">
            Add
          </Link>
        </div>
        <div className="tablebox">
          <DataTable
            className="react-datatables"
            columns={columns}
            data={exchangeLists}
            pagination
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
          />
        </div>
      </div>
    </div>
  );
};

export default Exchangelist;